<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Uprawnienia {{ name }}</v-flex>

        <v-spacer></v-spacer>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="PERMISSION_RELATION.ADD">
            <v-btn large color="error" @click="showAddModal">DODAJ UPRAWNIENIE</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        deletePerm="PERMISSION_RELATION.DELETE"
        :headers="headers"
        :items="list"
        :actions="true"
        :editAction="false"
        @add="showAddModal"
        @delete="showDeleteDialog"
      ></material-table>
    </material-card>

    <material-dialog
      title="Potwierdź usunięcie"
      text="Czy napewno chcesz usunąć uprawnienie?"
      :show="!!idToDelete"
      :id="idToDelete"
      @close="hideDeleteDialog"
      @confirm="remove"
    ></material-dialog>

    <modal :show="showModal" @save="add" @close="hideModal"></modal>
  </v-container>
</template>
<script>
import { mapState } from 'vuex';

import store from '@/store/store';
import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import MaterialDialog from '@/components/material/Dialog';
import Modal from './add.modal';
import { listMixin } from '@/mixins/list';

export default {
  mixins: [
    listMixin(
      'roles/rolePermission',
      {
        listError: 'Nie udało się pobrać listy uprawnień.',
        added: 'Dodano uprawnienie.',
        addError: 'Nie udało się dodać uprawnienia.'
      },
      {},
      (to, from, next) => {
        store
          .dispatch(`roles/rolePermission/list`, parseInt(to.params.id))
          .then(() => next())
          .catch(err =>
            store.dispatch('notifyError', {
              title: messages.listError
            })
          );
      }
    )
  ],
  components: {
    MaterialCard,
    MaterialTable,
    MaterialDialog,
    Modal
  },
  methods: {
    // @vuese
    // Usuwa uprawnienie
    remove(id) {
      const data = { permissionId: id, roleId: this.roleId };
      store
        .dispatch(`roles/rolePermission/remove`, data)
        .then(() => this.notifySuccess('Usunięto uprawnienie.'))
        .catch(err => this.notifyError('Nie udało się usunąć uprawnienia.'));
    }
  },
  computed: {
    ...mapState({
      name: state => state.roles.data.name,
      roleId: state => state.roles.data.id,
      list: state =>
        state.roles.rolePermission.list.map(item => {
          item.name = item.permission.name;
          item.id = item.permission.id;
          item.fromParentString = item.fromParent ? 'Tak' : 'Nie';
          item.allowedString = item.allowed ? 'Tak' : 'Nie';
          item.forbidDelete = item.fromParent;
          return item;
        })
    })
  },
  data() {
    return {
      headers: [
        { text: 'Nazwa', value: 'name' },
        { text: 'Dozwolone', value: 'allowedString' },
        { text: 'Dziedziczone', value: 'fromParentString' }
      ]
    };
  }
};
</script>